import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ecp-dynamic-app-registry',
  templateUrl: './dynamic-app-registry.component.html'
})
export class DynamicAppRegistryComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
